export default "__VITE_ASSET__DPSKg1yy__"